import React, { Component } from 'react'
import styled from 'styled-components'
import TimelineList from './TimelineList'
import mobClockBg from '../static/images/objects/m_clock.png'
import clockBg from '../static/images/objects/clock.png'
import ReactTouchEvents from "react-touch-events";
import mobArrowPrev from '../static/images/icons/arrow_right.png'
import mobArrowNext from '../static/images/icons/arrow_left.png'
import arrowPrev from '../static/images/icons/arrow_down_1.png'
import arrowNext from '../static/images/icons/arrow_up.png'

import { media } from '../styles/vars'

const containerHeight = 350;

const Container = styled.div`
position:absolute;
top:0;
right:0;
left:0;
z-index:2;
height:${containerHeight}px;
background:url(${mobClockBg}) no-repeat;
background-position:center top;
background-size:315px;
${
    media.desktop`
    background-image:url(${clockBg});
    background-size:contain;
    height:800px;
    background-position:center right;
    position:relative;
    float:right;
    `
    }
`
const CarouselContainer = styled.div`
height:100%;
width:315px;
margin:0 auto;
display:flex;
justify-content:center;
align-items:flex-end;
transition:transform .7s, opacity .7s;
transition-timing-function:ease-in-out;
transform:translate3d(0, -${containerHeight - 55}px, 0)
rotate3d(0, 0, 1, ${props => {
        switch (props.index) {
            case 0:
                return '30deg';
            case 2:
                return '-30deg';
            default:
                return 0;
        }
    }});

    ${props => props.animate ? `
    opacity:.1;
    transform:translate3d(0, -${containerHeight - 55}px, 0)
              rotate3d(0 ,0, 1, ${props.animationDir === 'right' ? '-10deg' : '10deg'});
    ` : ''}


    ${
    media.desktop`
        width:700px;
        display:block;
        transform:${props => {
            if (props.isFirst)
                return 'translate3d(-40px, 348px,0)';
            if (props.isLast)
                return 'translate3d(-38px,88px,0)';

            return 'translate3d(0, 218px, 0)';
        }};
        `
    }
`

const Arrow = styled.div`
position:absolute;
top:40px;
margin:auto 0;
right:${props => props.right ? '10px' : 'initial'};
left:${props => props.right ? 'initial' : '10px'};
width:20px;
filter:${props => props.active ? 'unset' : 'grayscale(100%)'};
transition:filter .4s;
z-index:10;
${
    media.desktop`
    cursor:pointer;
    width:52px;
    height:34px;
    left:6px;
    right:initial;
    top:${props => props.right ? '320px' : 'initial'};
    bottom:${props => props.right ? 'initial' : '320px'};
    `
    }
`
const ArrowImg = styled.img`
display: ${props => props.desktopOnly ? 'none' : 'block'};
${
    media.desktop`
    display: ${props => props.desktopOnly ? 'block' : 'none'};
    `
    }
`
class TimelineCarousel extends Component {
    constructor() {
        super();
        this.handleSwipe = this.handleSwipe.bind(this);
        this.nextItem = this.nextItem.bind(this);
        this.prevItem = this.prevItem.bind(this);

        this.state = {
            itemSet: [],
            setIdx: -1
        }

        this.bulkSize = 3;
    }
    componentDidMount() {
        this.goToIndex(0);
    }
    goToIndex(idx, selectedIndex) {
        if (this.state.triggerTransition) return;

        const start = idx;
        const end = (start) + this.bulkSize;
        let set = this.list.slice(start, end);
        const _selectedIndex = selectedIndex || 0;
        set.forEach((item, idx) => item.selected = _selectedIndex === idx);
        this.setState({
            triggerTransition: true,
            isFirstItem: idx === 0 && _selectedIndex === 0,
            isLastItem: idx === this.list.length - 3 && _selectedIndex === 2,
            animationDir: (idx === this.state.setIdx) ?
                (_selectedIndex > this.state.selectedIdx ?
                    'right' : 'left') : (idx > this.state.setIdx ? 'right' : 'left')
        });
        setTimeout(() => {
            this.setState({
                itemSet: set,
                setIdx: idx,
                selectedIdx: _selectedIndex,
                triggerTransition: false
            });
            this.props.onItemSelect(set.find(item => item.selected), this.state.carouselMoved);
        }, 600);
    }
    showNextSet() {
        if (this.state.setIdx === this.list.length - 3) {
            const selected = this.state.selectedIdx === 0 ? 1 :
                this.state.selectedIdx === 1 ? 2 : -1;
            if (selected !== -1) {
                this.goToIndex(this.list.length - 3, 2);
            }
            else {
                this.goToIndex(0, 0);
            }
            return;
        }
        const increment = this.state.setIdx === 0
            && this.state.selectedIdx === 0 ? 0 : 1;

        const selected = 1;
        this.goToIndex(this.state.setIdx + increment, selected);
    }
    showPrevSet() {
        if (this.state.setIdx === 0 && this.state.selectedIdx === 0) {
            this.goToIndex(this.list.length - 3, 2);
            return;
        }
        else if (this.state.setIdx === this.list.length - 3) {
            const selected = this.state.selectedIdx === 2 ? 1 : -1;
            if (selected !== -1) {
                this.goToIndex(this.list.length - 3, selected);
                return;
            }
        }
        const decrease = this.state.setIdx === 0
            && this.state.selectedIdx === 1 ? 0 : 1;

        const selected = decrease === 0 ? 0 : 1;
        this.goToIndex(this.state.setIdx - decrease, selected);
    }
    nextItem() {
        if (!this.state.carouselMoved) {
            this.setState({
                carouselMoved: true
            });
        }
        this.showNextSet();
    }
    prevItem() {
        if (!this.state.carouselMoved &&
            this.state.setIdx === 0 &&
            this.state.selectedIdx === 0) return;

        this.showPrevSet();
    }
    handleSwipe(direction) {
        direction === "right" ? this.nextItem() : this.prevItem();
    }
    render() {
        this.list = this.props.items;
        return (
            <Container>
                <Arrow
                    right
                    active={this.state.carouselMoved}
                    onClick={this.prevItem}
                >
                    <ArrowImg src={mobArrowPrev} alt="" />
                    <ArrowImg src={arrowPrev} alt="" desktopOnly />
                </Arrow>
                <ReactTouchEvents
                    onSwipe={this.handleSwipe}
                >
                    <CarouselContainer
                        index={this.state.selectedIdx}
                        animate={this.state.triggerTransition}
                        animationDir={this.state.animationDir}
                        isFirst={this.state.isFirstItem}
                        isLast={this.state.isLastItem}
                    >
                        <TimelineList
                            isFirst={this.state.isFirstItem}
                            isLast={this.state.isLastItem}
                            items={this.state.itemSet}
                        ></TimelineList>
                    </CarouselContainer>
                </ReactTouchEvents>
                <Arrow
                    active={true}
                    onClick={this.nextItem}
                >
                    <ArrowImg src={mobArrowNext} alt="" />
                    <ArrowImg src={arrowNext} alt="" desktopOnly />
                </Arrow>
            </Container>
        )
    }
}

export default TimelineCarousel;


// WEBPACK FOOTER //
// ./src/components/TimelineCarousel.jsx